<div>
  <wl-invoice-summary *ngIf="!isNewMemberInvoice" [invoice]="invoice" [isEditable]="false"></wl-invoice-summary>
  <div class="existing-payments">
    <wl-invoice-payments-list [invoice]="invoice" [flatPaymentIds]="flatPaymentIds"></wl-invoice-payments-list>
  </div>
  <div [hidden]="!isNewMemberInvoice && !addingNewPayment"
    [ngClass]="flatPaymentIds.length % 2 == 1 ? 'alt-row p-10 mb-10' : 'p-10 mb-10'">
    <wl-invoice-payment-header [paymentHeader]="invoice.PaymentHeader" [creditCardPayment]="creditCardPayment"
      [paymentTypes]="paymentTypes" [paymentSources]="paymentSources" [paymentTypeInvalid]="paymentTypeInvalid"
      (amountChanged)="amountChanged()" (paymentTypeSelected)="onPaymentTypeSelected()"></wl-invoice-payment-header>

    <hr />

    <div>
      <div class="payment-row-container mv-10">
        <span>{{ 'invoices.invoice-builder.payment-tab.payment-to-apply' | translate | titlecase }}</span>
        <span class="adjusted-amount-due-cell">{{
          'invoices.invoice-builder.payment-tab.adjusted-amount-due' | translate | titlecase
          }}</span>
        <span>{{ 'invoices.invoice-builder.payment-tab.revenue-item' | translate | titlecase }}</span>
        <span>{{ 'invoices.invoice-builder.payment-tab.payment-type' | translate | titlecase }}</span>
      </div>
      <div class="payment-row-container mv-10" *ngFor="let lineItem of invoice.LineItems">
        <input class="payment-to-apply-cell" type="number" min="0" [(ngModel)]="lineItem.PaymentAmountToApply"
          (keydown)="preventNegativeKey($event)" (blur)="sanitizePaymentAmount(lineItem)"
          (change)="sanitizePaymentAmount(lineItem)" />
        <span class="adjusted-amount-due-cell">{{ lineItem.AdjustedAmountDue | currency: 'USD':'symbol' }}</span>
        <span> {{ lineItem.Item }} </span>
        <p-select optionLabel="PaymentType" dataKey="PaymentTypeId"
          placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
          [disabled]="isPaymentTypeLockedByLineItem(lineItem)"
          [options]="getPaymentTypesForLineItem(lineItem)" [style]="{ width: '100%' }"
          [(ngModel)]="lineItem._paymentType"></p-select>
      </div>
      <div *ngFor="let lineItem of invoice.LineItems">
        <div class="payment-row-container mv-10" *ngFor="let taxLineItem of lineItem.TaxLineItems">
          <input class="payment-to-apply-cell" type="number" min="0" [(ngModel)]="taxLineItem.PaymentAmountToApply"
            (keydown)="preventNegativeKey($event)" (blur)="sanitizeTaxPaymentAmount(taxLineItem)"
            (change)="sanitizeTaxPaymentAmount(taxLineItem)" />
          <span class="adjusted-amount-due-cell">{{ taxLineItem.AdjustedAmountDue | currency: 'USD':'symbol' }}</span>
          <span> {{ taxLineItem.Item }} </span>
          <p-select optionLabel="PaymentType" dataKey="PaymentTypeId"
            placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
            [disabled]="isPaymentTypeLockedByLineItem(taxLineItem)"
            [options]="getPaymentTypesForLineItem(taxLineItem)" [style]="{ width: '100%' }"
            [(ngModel)]="taxLineItem._paymentType"></p-select>
        </div>
      </div>
      <div class="payment-row-container">
        <span><strong>{{ totalPaymentAmount | currency: 'USD':'symbol' }}</strong></span>
        <span class="adjusted-amount-due-cell"><strong>{{ totalAdjustedAmountDue | currency: 'USD':'symbol'
            }}</strong></span>
      </div>
    </div>
  </div>
  <div *ngIf="!addingNewPayment" class="apply-payment-button mct-flex mct-row mct-justify-start mct-items-stretch"  >
    <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="addPayment()">
      <i class="pi pi-plus"></i>
      {{ 'invoices.invoice-builder.payment-tab.add-a-payment' | translate | uppercase }}
    </button>
  </div>
  <div *ngIf="addingNewPayment" class="apply-payment-button mct-flex mct-row mct-justify-start mct-items-stretch"  >
    <button pButton type="button" class="btn btn-danger" (click)="cancelPayment()">
      <i class="pi pi-times"></i>
      {{ 'invoices.invoice-builder.payment-tab.cancel-payment' | translate | uppercase }}
    </button>
  </div>
</div>
